module.exports = __webpack_public_path__ + "static/media/icon6.852d2d18.svg";